import { createContext, useContext, useMemo } from "react"
import type { CSSProperties, PropsWithChildren } from "react"
import type { DraggableSyntheticListeners, UniqueIdentifier } from "@dnd-kit/core"
import { useSortable } from "@dnd-kit/sortable"
import { CSS } from "@dnd-kit/utilities"
import { TwinDictionary } from '../../../../../../utils/globals/dictionary'
import { RowData } from '../../../../types'
import TwinIcon from '../../../../../TwinIcon'
import './../../../../../TwinTable/InputTableLayout/inputtablelayout.sass'
import { faGripDotsVertical } from '@fortawesome/pro-light-svg-icons'

interface Props {
    id: UniqueIdentifier;
    className?: string
    data?: TwinDictionary
    style?: TwinDictionary
}

interface Context {
    attributes: Record<string, any>;
    listeners: DraggableSyntheticListeners;
    ref(node: HTMLElement | null): void;
}

const SortableItemContext = createContext <Context>({
    attributes: {},
    listeners: undefined,
    ref() { }
})

export function ITSortableItem({ children, id, className, data, style }: PropsWithChildren<Props>) {
    const {
        attributes,
        isDragging,
        listeners,
        setNodeRef,
        setActivatorNodeRef,
        transform,
        transition
    } = useSortable({ id, data})
    const context = useMemo(
        () => ({
            attributes: {...attributes},
            listeners,
            ref: setActivatorNodeRef
        }),
        [attributes, listeners, setActivatorNodeRef]
    )
    const myStyle: CSSProperties = {
        opacity: isDragging ? 0.7 : undefined,
        background: isDragging ? '#fff' : undefined,
        transform: CSS.Translate.toString(transform),
        transition,
        zIndex: isDragging? 2: undefined,
        ...style
    }
    return (
        <SortableItemContext.Provider value={context}>
            <div className={"SortableItem flex items-center " + (className || '')} ref={setNodeRef} style={myStyle}>
                {children}
            </div>
        </SortableItemContext.Provider>
    );
}

export interface ITDragHandleProps {
    allRowData: RowData
    readOnlyFnc?: (allRowData: RowData) => boolean

}
export function ITDragHandle({ allRowData, readOnlyFnc }: ITDragHandleProps) {
    const { attributes, listeners, ref } = useContext(SortableItemContext)
    const readOnly = readOnlyFnc?.(allRowData) || false
    if (readOnly) {
        return null
    }
    return (
        <button className="DragHandle mx-auto p-3 cursor-move regular14 flex items-center" {...attributes} {...listeners} ref={ref}>
            <TwinIcon icon={faGripDotsVertical} className='row_icon'/>
        </button>
    )
}